import axios from 'axios';
import * as Config from '../../config';

const state = {

};

const actions = {

    load_TypesUser({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'type/user/list/all')
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },

};

const mutations = {

};

export default {
    state,
    actions,
    mutations
};
